import { generateUuid, parseOptions, makeToast } from './helpers'
import { ToastRack } from './toast-rack'
import { EVENT_TOAST_SHOW, EVENT_STATIC_TOAST_SHOW } from './constants'

export class ToastMaker {
  constructor(vm, _options) {
    this._vm = vm
    this._root = vm.$root

    /**
     * Unique id of the toast
     */
    this.id = generateUuid()

    /**
     * Shared Options of the Toast
     */
    this.options = parseOptions(_options)

    /**
     * All Registered Toasts
     */
    this.toasts = []

    /**
     * Element of the Toast Container
     */
    this.container = null

    this.toaster = null

    this.toasterName = 'toaster'
    this.computedToaster = ''
  }

  ensureToaster() {
    if (!document.querySelectorAll('.toaster.toaster-root').length) {
      const div = document.createElement('div')
      document.body.appendChild(div)
      const toaster = new ToastRack({
        propsData: {
          position: this.options.position,
        }
      })
      toaster.$mount(div)
    }
  }

  toast(message, options) {
    const _options = {...this.options, ...options}
    this.ensureToaster()
    this._root.$emit(EVENT_STATIC_TOAST_SHOW, { options: _options })
    return generate(this, message, _options)
  }

  show(id, options = {}) {
    const _options = {...this.options, ...options}
    this.ensureToaster()
    this._root.$emit(EVENT_TOAST_SHOW, { id, options: _options })
  }
}

/**
 * Wrapper for show method in order to manipulate options
 *
 * @param instance
 * @param message
 * @param options
 * @returns {*}
 * @private
 */
function generate(instance, message, options) {
  options = options || {}
  let toast = null
  if (!message) {
    return
  }

  if (typeof options !== 'object') {
    console.error('Options should be a type of object. given : ' + options)
    return null
  }

  // clone the global options
  const _options = Object.assign({}, instance.options)

  // merge the cached global options with options
  Object.assign(_options, options)

  toast = makeToast(instance, message, _options)
  instance.toasts.push(toast)

  return toast
}
